import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { path: '/backoffice', name: 'Overview', icon: FiIcons.FiGrid },
  { path: '/backoffice/wineries', name: 'Wineries', icon: FiIcons.FiBriefcase },
  { path: '/backoffice/contact-requests', name: 'Contact requests', icon: FiIcons.FiMail },
];

const PlatformLayout: React.FC = () => {
  const { logout } = useAuth();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/backoffice') {
      return location.pathname === '/backoffice';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-neutral-50 text-neutral-900">
      <header className="bg-primary-700 text-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center gap-6">
              <Link to="/backoffice" className="flex items-center gap-2 font-semibold tracking-tight">
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 ring-1 ring-white/15">
                  {FiIcons.FiLayers({ size: 16 })}
                </span>
                <span>Sotimer Platform</span>
              </Link>

              <nav className="hidden sm:flex items-center gap-1">
                {navItems.map((item) => {
                  const active = isActive(item.path);
                  const Icon = item.icon;
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                        active
                          ? 'bg-white/15 text-white'
                          : 'text-white/75 hover:text-white hover:bg-white/10'
                      }`}
                    >
                      {Icon({ size: 15 })}
                      {item.name}
                    </Link>
                  );
                })}
              </nav>
            </div>

            <div className="flex items-center gap-2">
              <Link
                to="/dashboard"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-white/80 hover:text-white hover:bg-white/10 transition-colors"
              >
                {FiIcons.FiArrowLeft({ size: 15 })}
                <span className="hidden sm:inline">Back to app</span>
              </Link>
              <button
                onClick={logout}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-white/80 hover:text-white hover:bg-white/10 transition-colors"
              >
                {FiIcons.FiLogOut({ size: 15 })}
                <span className="hidden sm:inline">Logout</span>
              </button>
            </div>
          </div>

          <nav className="sm:hidden flex gap-1 pb-3 overflow-x-auto">
            {navItems.map((item) => {
              const active = isActive(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`shrink-0 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                    active
                      ? 'bg-white/15 text-white'
                      : 'text-white/75 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default PlatformLayout;
